// extracted by mini-css-extract-plugin
export default {"root":"_17hyIrJX","cover":"_1nw4iph5"};